<script>
import { Cropper } from "vue-advanced-cropper";

export default {
  name: "SubpackageImageCroperModel",
  props: {
    visible: Boolean,
    closeable: Boolean,
    imageFile: Object,
  },
  components: {
    Cropper,
  },
  data() {
    return {
      imageCanvas: null,
      croppedImage: null,
      croppedCanvas: null,
    };
  },
  computed: {
    showModal: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit("close");
        }
      },
    },
  },
  mounted() {
    const cropperFileReader = new FileReader();
    cropperFileReader.readAsDataURL(this.imageFile);
    cropperFileReader.onload = (e) => {
      this.$refs.cropper.src = e.target.result;
    };
  },
  methods: {
    cropperChange({ canvas }) {
      this.croppedCanvas = canvas;
    },
    applyCropImage() {
      this.$emit("apply", this.croppedCanvas);
    },
    cancel() {
      this.$emit("close");
    },
  },
};
</script>

<template>
  <b-modal
    v-model="showModal"
    centered
    hide-footer
    :title="this.$i18n.t('packages.editPackage.titleImageCropper')"
    no-close-on-backdrop
    no-close-on-esc
    header-close-content
  >
    <div class="row">
      <div class="col-lg-12">
        <!-- Company image -->
        <div>
          <cropper
            ref="cropper"
            :stencil-props="{
              aspectRatio: 740 / 480,
            }"
            classname="cropper"
            @change="cropperChange"
          ></cropper>
        </div>
      </div>

      <div class="p-4 col-md-12 text-lg-center">
        <b-button variant="success" @click="applyCropImage" class="mr-2"
          >Zuschneiden</b-button
        >
        <b-button variant="light" @click="showModal = false"
          >Abbrechen</b-button
        >
      </div>
    </div>
  </b-modal>
</template>